import React from "react";
import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";

export function DashboardSmallChart({ data, colors }) {
  const options = {
    chart: {
      id: "basic-bar",
      sparkline: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 400,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 150,
        },
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },

    yaxis: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div className="bg-white py-2 px-2 text-xs border-[.5px] border-border">' +
          "Total:" +
          " " +
          '<span className="font-semibold">' +
          series[seriesIndex][dataPointIndex] +
          "</span>" +
          "</div>"
        );
      },
    },
    grid: {
      show: false,
    },
    plotOptions: {
      bar: {
        columnWidth: "75%",
        distributed: false,
        borderRadius: 2,
      },
    },
    colors: [colors],
  };
  const series = [
    {
      name: "series-1",
      data: data,
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      width="100%"
      height={50}
    />
  );
}

export function DashboardBigChart({ datos }) {
  const options = {
    chart: {
      id: "area-datetime",
      toolbar: {
        show: false,
      },
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 1000,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 800,
        },
      },
    },
    xaxis: {
      categories: datos?.map((obj) => obj.id),
      labels: {
        show: true,
        style: {
          colors: "#A0A0A0",
          fontSize: "12px",
          fontWeight: 400,
        },
      },
      axisTicks: {
        show: false,
      },
    },

    yaxis: {
      show: true,
      labels: {
        show: true,
        style: {
          colors: "#A0A0A0",
          fontSize: "10px",
          fontWeight: 400,
        },
        formatter: function (value) {
          return value;
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div className="bg-white py-2 px-2 text-xs border-[.5px] border-border">' +
          "Total:" +
          " " +
          '<span className="font-semibold">' +
          series[seriesIndex][dataPointIndex] +
          "</span>" +
          "</div>"
        );
      },
    },
    grid: {
      show: true,
      borderColor: "#E8EBEE",
      strokeDashArray: 4,
      position: "back",
    },
    stroke: {
      curve: "smooth",
      width: 1,
    },

    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: true,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    colors: ["#66B5A3"],
  };
  const series = [
    {
      name: "Total",
      data: datos?.map((obj) => obj.valor),
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="area"
      width="100%"
      height={300}
    />
  );
}

export function ComparativeChart({ name, data }) {
  const options = {
    chart: {
      id: "area-datetime",
      toolbar: {
        show: false,
      },
      animations: {
        enabled: false,
        easing: "easeinout",
        speed: 1000,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 800,
        },
      },
    },
    xaxis: {
      categories: data?.map((item) =>
        new Date(item.fecha).toLocaleDateString("en-gb")
      ),
      labels: {
        show: true,
        style: {
          colors: "#A0A0A0",
          fontSize: "12px",
          fontWeight: 400,
        },
      },
      axisTicks: {
        show: false,
      },
    },

    yaxis: {
      show: true,
      labels: {
        show: true,
        style: {
          colors: "#A0A0A0",
          fontSize: "10px",
          fontWeight: 400,
        },
        formatter: function (value) {
          return value;
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div className="bg-white py-2 px-2 text-xs border-[.5px] border-border">' +
          "Total:" +
          " " +
          '<span className="font-semibold">' +
          series[seriesIndex][dataPointIndex] +
          "</span>" +
          "</div>"
        );
      },
    },
    grid: {
      show: true,
      borderColor: "#E8EBEE",
      strokeDashArray: 4,
      position: "back",
    },
    stroke: {
      curve: "smooth",
      width: 1,
    },

    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: true,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    colors: ["#66B5A3"],
  };
  const series = [
    {
      name: "Valor",
      data: data?.map((item) => item.value),
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="area"
      width="100%"
      height={300}
    />
  );
}

export function ChartPediatrics({ datas, options }) {
  const [state, setState] = React.useState({
    series: [
      {
        name: options?.names[0],
        data: datas?.sd3 || [],
      },
      {
        name: options?.names[1],
        data: datas?.sd2 || [],
      },
      {
        name: options?.names[2],
        data: datas?.median || [],
      },
      {
        name: options?.names[3],
        data: datas?.sdneg2 || [],
      },
      {
        name: options?.names[4],
        data: datas?.sdneg3 || [],
      },
      // Paciente
      {
        name: "El paciente",
        data: datas?.patient || [],
      },
    ],
    options: options || {},
  });

  // Al abrir el modal, ApexCharts mide el ancho antes de que el modal termine de renderizar → la
  // conversión píxel→dato queda mal y el "pan" (arrastrar) se mueve más rápido que el mouse. Forzamos
  // que recalcule el ancho una vez que el modal ya está estable disparando un par de "resize".
  React.useEffect(() => {
    const timers = [120, 350, 700].map((ms) =>
      setTimeout(() => window.dispatchEvent(new Event("resize")), ms)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  React.useEffect(() => {
    setState({
      series: [
        {
          name: options?.names[0],
          data: datas?.sd3 || [],
        },
        {
          name: options?.names[1],
          data: datas?.sd2 || [],
        },
        {
          name: options?.names[2],
          data: datas?.median || [],
        },
        {
          name: options?.names[3],
          data: datas?.sdneg2 || [],
        },
        {
          name: options?.names[4],
          data: datas?.sdneg3 || [],
        },
        // Paciente
        {
          name: options?.names[5] || "El paciente",
          data: datas?.patient || [],
          color: "#000",
          stroke: {
            width: 0, // sin línea
          },
          markers: {
            size: 6,
            shape: "circle",
          },
        },
      ],
    });
    console.log("Datos actualizados:", datas);
    console.log("Opciones actualizadas:", options);
  }, [datas]);

  const modifiedOptions = {
    ...options.options,
    yaxis: {
      ...options.options?.yaxis,
      labels: {
        ...options.options?.yaxis?.labels,
        formatter: function (value) {
          return typeof value === "number" ? Math.round(value) : value;
        },
      },
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={modifiedOptions}
          series={state.series}
          type="line"
          height={400}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
}
